import { Value } from 'theme/style'

const style = {
  paper: {
    borderRadius: Value.BorderRadius + '! important',
  },
}

export default style
